import { forwardRef } from 'react'
import { FileBlock, type CommonBlockProps } from '../../../types'
import { webchatClasses } from '../../../styles/classes'
import { FileDown } from 'lucide-react'

type Props = FileBlock & CommonBlockProps

export const File = forwardRef<HTMLAnchorElement, Props>(({ title, url, isReadOnly, ...props }, ref) => {
  const {
    message: {
      blocks: { file },
    },
  } = webchatClasses

  return (
    <a
      {...props}
      {...file.container}
      href={url}
      style={isReadOnly ? { pointerEvents: 'none' } : undefined}
      download
      ref={ref}
      target="_blank"
      rel="noreferrer"
    >
      <p {...file.title}>{title || url}</p>
      <FileDown {...file.icon} />
    </a>
  )
})

File.displayName = 'File'
